import React, { useState } from 'react'
import { ActionIcon, Anchor, Group, Text, Tooltip } from '@mantine/core'
import { EyeOpenIcon, LockClosedIcon } from '@radix-ui/react-icons'

import { canPreviewExhibit } from './ExhibitFilePreview'

import { CourtReporterExhibit } from '@/apiClient'

export const ExhibitFileLink: React.FC<{
  exhibit: CourtReporterExhibit
  onPreview: () => void
}> = ({ exhibit, onPreview }) => {
  if (!exhibit.file) {
    return (
      <Text size="sm" color="dimmed">
        No file
      </Text>
    )
  }

  if (!exhibit.file.url) {
    return (
      <Text size="sm" color="dimmed" className="truncate">
        {exhibit.file.filename} (processing)
      </Text>
    )
  }

  return (
    <Group spacing={4} noWrap>
      <Anchor
        size="sm"
        href={exhibit.file.url}
        target="_blank"
        className="block min-w-0 truncate"
        title={exhibit.file.filename}
      >
        {exhibit.file.filename}
      </Anchor>
      {canPreviewExhibit(exhibit) && (
        <Tooltip label="Preview file" withinPortal>
          <ActionIcon
            size="sm"
            aria-label={`Preview ${exhibit.file.filename}`}
            onClick={onPreview}
          >
            <EyeOpenIcon />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  )
}

// Shows the whole text on hover, but only when the clamp actually cut it.
export const ClampedText: React.FC<{ text: string; lines: number }> = ({
  text,
  lines,
}) => {
  const [opened, setOpened] = useState(false)

  return (
    <Tooltip
      label={<span className="whitespace-pre-wrap">{text}</span>}
      opened={opened}
      multiline
      width={320}
      withinPortal
    >
      <Text
        size="sm"
        lineClamp={lines}
        onMouseEnter={e =>
          setOpened(e.currentTarget.scrollHeight > e.currentTarget.clientHeight)
        }
        onMouseLeave={() => setOpened(false)}
      >
        {text}
      </Text>
    </Tooltip>
  )
}

export const ReadOnlyExhibitIcon: React.FC = () => (
  <Tooltip
    label="Added by Filevine. You can't change this exhibit."
    withinPortal
  >
    <span aria-label="Read-only exhibit" className="inline-flex text-gray-500">
      <LockClosedIcon />
    </span>
  </Tooltip>
)
